// extracted by mini-css-extract-plugin
export var lg = "_dz-7";
export var md = "_dz-6";
export var placeholderContainer = "_dz-1";
export var placeholderIcon = "_dz-2";
export var productImage = "_dz-0";
export var sm = "_dz-5";
export var xl = "_dz-8";
export var xs = "_dz-4";
export var xxs = "_dz-3";